export default __webpack_public_path__ + "static/media/airIndia.1dff4a8f.png";